import React, {memo, useState} from 'react'
import {
    Alert,
    AlertColor,
    Button,
    ButtonGroup,
    Checkbox,
    Snackbar,
Tooltip
} from "@mui/material";
import PersonPhotoIcon from "../../assets/Images/photo1.png";
import ArrestIcon from "../../assets/Images/ai1.png";
import InfoCopIcon from "../../assets/Images/ic1.png";
import ETicketIcon from "../../assets/Images/et1.png";
import ParkMobileIcon from "../../assets/Images/pm1.png";
import ALPRIcon from "../../assets/Images/alpr1.png";
import CADRMSIcon from "../../assets/Images/Opencase1.png";
import CODISIcon from "../../assets/Images/DNA1.png";
import TowingIcon from "../../assets/Images/towing1.png";
import PrisonReleaseIcon from "../../assets/Images/jail1.png";
import GunTraceIcon from "../../assets/Images/WeaponTrace1.png";
import ShootingIcon from "../../assets/Images/Shooting.png";
import ShootingSuspectIcon from "../../assets/Images/ShootingRed.png";
import ShootingVictimIcon from "../../assets/Images/ShootingGreen.png";
import NibinIcon from "../../assets/Images/nibin1.png";
import NJGunTraceIcon from "../../assets/Images/NjGunTrace1.png";
import PrisonParoleInactiveIcon from "../../assets/Images/parole_Inactive.png";
import PrisonParoleActiveIcon from "../../assets/Images/parole1.png";
import ViolentIcon from "../../assets/Images/Violent1.png";
import HumanTrafficIcon from "../../assets/Images/HumanTraffic1.png";
import ProfesionIcon from "../../assets/Images/profession1.png";
import ReferralIcon from "../../assets/Images/Referral1.png";
import ReferralRearrestedIcon from "../../assets/Images/ReferralRearrested1.png";
import ArrestRecentIcon from "../../assets/Images/aiRecent.png";
import PrisonReleaseRecentIcon from "../../assets/Images/jailRecent.png";
import GunTraceRecentIcon from "../../assets/Images/WeaponTraceTTC.png";
import NJGunTraceTriggerLockIcon from "../../assets/Images/NjGunTraceTrigerLock.png";
import ProfileIcon from "../../assets/Images/profile.png";
import DomViolenceIcon from "../../assets/Images/domesticviolence.png";
import SexCrimeIcon from "../../assets/Images/sexcrime.png";
import {
    ColumnDirective,
    ColumnsDirective,
    ColumnMenu,
    GridComponent,
    Grid,
    Inject,
    Page,
    Sort,
    Filter,
    DetailRow,
    ExcelExport,
    PdfExport,
    Toolbar,
    Search, ExcelExportProperties,
    Resize, Reorder, SortSettingsModel, Column
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-navigations';
import PriorReferralGrid from "./_resultsPriorReferralsGrid";
import GVRTFOutputForm from "./GVRTF_OutputForm";
import BTPersonReport from "../shared/_BTPersonReport";
import { Avatar } from "@mui/material";
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import { green } from '@mui/material/colors';
import { JAOS } from '../../services/JAOS.service';
import { isUserPermission } from '../../services/auth.service';
import NCICIcon from '../../assets/Images/NCIC.png';
import {getValue} from "@syncfusion/ej2-base";
import BTPersonIndicatorGrid from "../shared/_PersonIndicators";
import {GetStringNameForSite} from "../../interfaces/config.interface";
import {SiteName} from "../../services/config.service";

interface SearchResultsProps {
    Persons: any[]
    UpdateReferralList? : any
}

const ReferralGrid1: React.FC<SearchResultsProps> = ({Persons, UpdateReferralList})=> {
    const [typedPersons, setTypedPersons] = React.useState<any[]>([])
    //Alerts
    const [alertOpen, setAlertOpen] = React.useState<boolean>(false)
    const [alertText, setAlertText] = React.useState<string>("")
    const [alertType, setAlertType] = React.useState<AlertColor>("error")
    const [ncicList, setNCICList] = React.useState<any[]>([])

    let grid: Grid | null;
    let selectedRows: any[] = [];
     

    const handleDataTyping = () => {
        if (Persons) {
            let tempP: any = [...Persons]
            //reset NCIClist if they search again
            setNCICList([])
            for (let p of tempP) {
                if (p.DOB) {
                    p.DOB = new Date(p.DOB)
                }
                if (p.DTOFARREST) {
                    p.DTOFARREST = new Date(p.DTOFARREST)
                }
                if (p.DTOFUPDATE) {
                    p.DTOFUPDATE = new Date(p.DTOFUPDATE)
                }
            }
            setTypedPersons(tempP)
        }
    }

    React.useEffect(() => {
        handleDataTyping()
    },[Persons])

    //let grid: Grid | null;

    const GridToolsClick = (args: ClickEventArgs) => {
        
        if (grid && args.item.text === "Excel Export") {

            let excelProp: ExcelExportProperties = {}
            excelProp.fileName = 'Referrals.xlsx';

            (grid.getColumnByField("Referral_County") as Column).visible = true;
            (grid.getColumnByField("RTCC") as Column).visible = true;
            (grid.getColumnByField("Indicator") as Column).visible = false;

            grid.excelExport(excelProp);

        } else if (grid && args.item.text === 'PDF Export') {
            grid.pdfExport();
        }
        else if (grid && args.item.text === 'Clear Selected'){
            grid.clearSelection()
            selectedRows=[]        
        }
    }

    const excelExportComplete = () => {
        if (grid) {
            (grid.getColumnByField("Referral_County") as Column).visible = false;
            (grid.getColumnByField("RTCC") as Column).visible = false;
            (grid.getColumnByField("Indicator") as Column).visible = true;
        }
    }

    const excelQueryCellInfo = (args: { column: { customExcelTemplate: (arg0: any) => any; }; value: string; data: any; }) => {
        //console.log(args)
        /*if (has(args.column, "customExcelTemplate")) {
            args.value = toString(args.column.customExcelTemplate(args.data));
        }*/
    };

    const gridTemplate = (person: any): any => {
        return (
            <BTPersonIndicatorGrid person={person} />
        );
    }

    const dataBound = () => {
        if(grid){
            grid.autoFitColumns([])
        }
    }

    const expandRow = (args: any) => {
         //expand if a row is selected except select checkbox
        // if(args?.name === 'rowSelected' && args?.target.ariaLabel != null || args?.target.alt){
        //     if(grid){
        //         const selectedrowindex= grid.getSelectedRowIndexes()
        //         for (let idx of selectedrowindex) {
        //             grid.detailRowModule.expand(idx)
        //         }
        //     }
        
        // }
        let rows = [...selectedRows];
        if (args?.isHeaderCheckboxClicked){
            rows = [];
            for (let idx = 0; idx < typedPersons.length; idx++) {
                let person: any = typedPersons[idx];
                if (person && person.PersonID) {
                    rows.push(person)
                }
            }
        }
        else {
            if  (args?.data && args?.data?.length !== typedPersons.length) {
                var result = rows.findIndex(x => x.PersonID === args?.data.PersonID)
                if (result === -1) {
                    let person = args?.data;
                    if (person && person.PersonID) {
                        rows.push(person)
                    }
                }
                else {
                    rows.splice(result,1)
                }
            }
        }
        selectedRows=rows    
    }

    const rowDeselect = (args: any) => {
        // if(args?.name === 'rowDeselected'){
        //     if(grid){
        //         grid.detailRowModule.collapseAll()
        //     }       
        // }
        let rows = [...selectedRows];
        if(args?.isHeaderCheckboxClicked){
            rows= [];
        }
        else {
            if (args?.data && args?.data?.length !== typedPersons.length) {
                var result = rows.findIndex(x => x.TableID === args?.data.TableID && x.TableType === args?.data.TableType)

                if (result === -1) {
                    let person = args?.data;
                    if (person && person.PersonID) {
                        rows.push(person)
                    }
                }
                else {
                    rows.splice(result, 1)
                }
            }
        }
        selectedRows = rows;

    }

    // const selectTemplate = (person: any): any => {
    //     return (
    //     <>
    //         <Checkbox onClick={ () => {buildNCICList(person)} }/>
    //     </>);
    // }

    // const buildNCICList = (person:any) => {
    //     //let rows = selectedRows
    //     let NCICListTemp = ncicList
    //     var result = NCICListTemp.findIndex(x => x.PersonID === person?.PersonID)
        
    //     if (result === -1) {
    //         NCICListTemp.push(person)
    //     }
    //     else {
    //         NCICListTemp.splice(result, 1)
    //     }
    //     setNCICList(NCICListTemp)       
    // } 


    const handleNCICSearch = () => {
        let tempSelectedRows = []
        for(let idx in selectedRows){
            tempSelectedRows.push({
                PersonID: selectedRows[idx].PersonID,
                TableID: selectedRows[idx].TableID,
                DLNo: selectedRows[idx].DLNo,
                FName: selectedRows[idx].FName,
                MName: selectedRows[idx].MName,
                LName: selectedRows[idx].LName,
                DOB: selectedRows[idx].DOB,
                FBI: selectedRows[idx].FBI,
                SBINo: selectedRows[idx].SBINo,
            })
        }
        if (tempSelectedRows.length > 0 && tempSelectedRows.length < 14001) {
            let l = new JAOS()
            let hashID = l.objToStack(tempSelectedRows);
            window.open('/tools/ncic_multiple_occurrence?person=' + hashID, '_blank')
        }
        else if (tempSelectedRows.length >= 14001){
            setAlertType("error");
            setAlertText("Please reduce selection size to 14000 to run NCIC search");
            setAlertOpen(true);
            grid?.clearSelection()
        }
        else {
            setAlertType("error");
            setAlertText("Please select at least one offender to run NCIC search");
            setAlertOpen(true);
        }
    }

    const getPersonSummary = (p:any) =>
    {
        return (<div><BTPersonReport person={p}/></div>)
    }
    
    /*const showAllReferrals = (p:any) => {
        return (<div><PriorReferralGrid Person={p} CurList = {[...Persons]}/></div>)
    }*/
    
    let sortSettings: SortSettingsModel = { columns: [
            {field: 'FName', direction: 'Ascending' }
    ] };

    const toolbarOptions: object[] = [
            {text:"Excel Export" , prefixIcon:"e-excelexport", tooltipText:"Excel Export",type: "Button",}, {text:"Search"}, {text:"Clear Selected", prefixIcon: "e-collapse-2", tooltipText:"Clear Selected", type: "Button"}
    ]

    return (
        <div className={"pl-10 pr-10 mt-5"}>
            {typedPersons && typedPersons.length>0? <>
                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={alertOpen} autoHideDuration={6000} onClose={() => { setAlertOpen(false) }}>
                    <Alert onClose={() => { setAlertOpen(false) }} severity={alertType} sx={{ width: '100%' }}>
                        {alertText}
                    </Alert>
                </Snackbar>
                <span  style ={{display:"inline-block"}} className='mb-5'>
                    <h4 className={"font-bold inline mr-5 pl-5"}> {typedPersons?.length} Offender(s) Found</h4>
                    {isUserPermission('NCIC') ?
                        <ButtonGroup size="medium" color="inherit" className='mb-2 mr-2'>
                            <Tooltip title="Search NCIC Warrant Deatils for Select Offender(s)" placement="top" arrow>
                                <Button variant="outlined" onClick={handleNCICSearch}>
                                    <img src={NCICIcon} className={"mr-2"} alt={""} />NCIC Search
                                </Button>
                            </Tooltip>
                        </ButtonGroup> : <></>
                    } 
                </span>
                <GridComponent
                    dataSource={typedPersons}
                    //dataBound={dataBound}
                    allowPaging={true}
                    pageSettings={{pageSize: 25, pageSizes: [10,25,50,100]}}
                    allowSorting={true}
                    sortSettings={sortSettings}
                    allowMultiSorting={true}
                    allowFiltering={true}
                    filterSettings={{type: 'CheckBox'}}
                    detailTemplate={getPersonSummary}
                    allowTextWrap={true}
                    textWrapSettings={{ wrapMode: 'Both' }}
                    allowExcelExport={true}
                    allowPdfExport={true}
                    toolbar={toolbarOptions}
                    //toolbar={['ExcelExport','Search']}
                    toolbarClick={GridToolsClick}
                    excelExportComplete={excelExportComplete}
                    ref={g=> grid = g}
                    selectionSettings={{
                        persistSelection: true,
                        type: "Multiple",
                        checkboxOnly: true,
                        mode: "Row"}}
                    // rowSelecting = {(event:any) => {console.log(event)}}
                    //rowSelecting={(event: any) => { }}
                    rowSelected={(event: any) => { expandRow(event) }}
                    rowDeselected={(event: any) => { rowDeselect(event) }}
                    allowSelection={true}
                    allowResizing={true}
                    rowHeight={24}
                    rowDataBound={(args : any) => {
                        if (args.row) {
                            if (getValue('FoundJail', args.data)  === 2){
                                args.row.classList.add('red');
                            }
                        }
                    }}
                >
                    <ColumnsDirective>
                    <ColumnDirective field='ID' width={140} minWidth={140} maxWidth={140} headerText='ID' visible={false} isPrimaryKey={true} />
                        {isUserPermission('NCIC') ? <ColumnDirective type='checkbox' width='50' customAttributes={{ class: ['e-checkbox-custom'] }} /> : <></>}
                        {/* { isUserPermission('NCIC') ? <ColumnDirective template={selectTemplate} headerText='Select' width={100} /> : <></>} */}
                        <ColumnDirective field='FName' headerText='First Name' customAttributes={{ class: ['e-attr']}}/>
                        <ColumnDirective field='MName' headerText='MI' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='LName' headerText='Last Name' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='DOB'   format={{ type: 'date', format: 'MM/dd/yyyy' }} headerText='DOB' customAttributes={{ class: ['e-attr'] }} />
                        <ColumnDirective field='FBI'   headerText='FBI' customAttributes={{ class: ['e-attr'] }} />
                        <ColumnDirective field='SBINo' headerText={`${GetStringNameForSite(SiteName,'SBI #')}`} customAttributes={{ class: ['e-attr'] }} />
                        <ColumnDirective field='Status'  headerText='Status' customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='Referral_County'  headerText='Referral County' visible={false} customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective field='RTCC'  headerText='RTCC Location' visible={false} customAttributes={{ class: ['e-attr'] }}/>
                        <ColumnDirective template={gridTemplate} maxWidth={300} headerText='Indicator' field={"Indicator"} customAttributes={{ class: ['e-attr'] }}/>
                    </ColumnsDirective>
                    <Inject services={[ColumnMenu, Sort, Page, Filter, DetailRow, Toolbar, ExcelExport,PdfExport,Search, Resize, Reorder]}/>
                </GridComponent>
            </>:<></>}
        </div>
    );
};

export default memo(ReferralGrid1);